import { render } from "./ViewCollectors.vue?vue&type=template&id=81a38554&scoped=true"
import script from "./ViewCollectors.vue?vue&type=script&lang=js"
export * from "./ViewCollectors.vue?vue&type=script&lang=js"

import "./ViewCollectors.vue?vue&type=style&index=0&id=81a38554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a38554"]])

export default __exports__